// This script should be placed at the end of OrderVehicle.jsx or in a separate file

/**
 * Enhanced DatePicker functionality to properly block weekend dates
 * This script works by creating a custom date picker that can properly disable weekend dates
 * when the "Collection" option is selected for logistics.
 */
document.addEventListener('DOMContentLoaded', function () {
    // Function to check if a date is a weekend
    const isWeekend = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDay();
        return day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
    };

    // Function to format date as YYYY-MM-DD
    const formatDateString = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Create mutation observer to watch for logistics change
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-restrict-weekends') {
                const dateInput = mutation.target;

                // Add event listener to prevent opening the native date picker
                dateInput.addEventListener('click', (e) => {
                    if (dateInput.getAttribute('data-restrict-weekends') === 'true') {
                        e.preventDefault();
                        openCustomDatePicker(dateInput);
                    }
                });
            }
        });
    });

    // Initialize observation of date inputs
    const dateInputs = document.querySelectorAll('input[type="date"]');
    dateInputs.forEach(input => {
        observer.observe(input, { attributes: true });

        // Also add event listener directly in case attribute is already set
        if (input.getAttribute('data-restrict-weekends') === 'true') {
            input.addEventListener('click', (e) => {
                e.preventDefault();
                openCustomDatePicker(input);
            });
        }
    });

    // Create a custom date picker that properly disables weekend dates
    function openCustomDatePicker(inputElement) {
        // Get current value or default to today
        const currentValue = inputElement.value ? new Date(inputElement.value) : new Date();
        const today = new Date();

        let currentMonth = currentValue.getMonth();
        let currentYear = currentValue.getFullYear();

        // Create calendar overlay
        const overlay = document.createElement('div');
        overlay.className = 'calendar-overlay';

        // Create calendar container
        const calendar = document.createElement('div');
        calendar.className = 'custom-calendar';

        // Function to render the calendar for a specific month/year
        function renderCalendar(month, year) {
            // Clear previous content
            calendar.innerHTML = '';

            // Create header
            const header = document.createElement('div');
            header.className = 'calendar-header';

            const title = document.createElement('div');
            title.className = 'calendar-title';
            title.textContent = new Date(year, month, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

            const nav = document.createElement('div');
            nav.className = 'calendar-nav';

            const prevBtn = document.createElement('button');
            prevBtn.innerHTML = '&lt;';
            prevBtn.addEventListener('click', () => {
                if (month === 0) {
                    renderCalendar(11, year - 1);
                } else {
                    renderCalendar(month - 1, year);
                }
            });

            const nextBtn = document.createElement('button');
            nextBtn.innerHTML = '&gt;';
            nextBtn.addEventListener('click', () => {
                if (month === 11) {
                    renderCalendar(0, year + 1);
                } else {
                    renderCalendar(month + 1, year);
                }
            });

            nav.appendChild(prevBtn);
            nav.appendChild(nextBtn);
            header.appendChild(title);
            header.appendChild(nav);
            calendar.appendChild(header);

            // Create day headers
            const grid = document.createElement('div');
            grid.className = 'calendar-grid';

            const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            dayNames.forEach(day => {
                const dayHeader = document.createElement('div');
                dayHeader.className = 'calendar-day-header';
                dayHeader.textContent = day;
                grid.appendChild(dayHeader);
            });

            // Get first day of month and last day
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);

            // Fill in days from previous month
            const daysFromPrevMonth = firstDay.getDay();
            const prevMonthLastDay = new Date(year, month, 0).getDate();

            for (let i = 0; i < daysFromPrevMonth; i++) {
                const dayElement = document.createElement('div');
                dayElement.className = 'calendar-day other-month';
                dayElement.textContent = prevMonthLastDay - daysFromPrevMonth + i + 1;
                grid.appendChild(dayElement);
            }

            // Fill in days of current month
            for (let day = 1; day <= lastDay.getDate(); day++) {
                const date = new Date(year, month, day);
                const dayElement = document.createElement('div');
                dayElement.className = 'calendar-day';
                dayElement.textContent = day;

                // Highlight today
                if (date.toDateString() === today.toDateString()) {
                    dayElement.classList.add('today');
                }

                // Highlight selected date
                if (currentValue && date.toDateString() === currentValue.toDateString()) {
                    dayElement.classList.add('selected');
                }

                // Mark weekends
                const isWeekendDay = date.getDay() === 0 || date.getDay() === 6;
                if (isWeekendDay) {
                    dayElement.classList.add('weekend');

                    // Disable weekends if "Collect" logistics
                    if (document.querySelector('select[name="logistics"]')?.value === 'Collect') {
                        dayElement.classList.add('disabled');
                    } else {
                        // Allow selecting weekends for Delivery
                        dayElement.addEventListener('click', () => {
                            inputElement.value = formatDateString(date);
                            // Trigger change event
                            const event = new Event('change', { bubbles: true });
                            inputElement.dispatchEvent(event);
                            document.body.removeChild(overlay);
                        });
                    }
                } else {
                    // Always allow selecting weekdays
                    dayElement.addEventListener('click', () => {
                        inputElement.value = formatDateString(date);
                        // Trigger change event
                        const event = new Event('change', { bubbles: true });
                        inputElement.dispatchEvent(event);
                        document.body.removeChild(overlay);
                    });
                }

                grid.appendChild(dayElement);
            }

            // Fill in days from next month
            const daysFromNextMonth = 42 - (daysFromPrevMonth + lastDay.getDate());
            for (let i = 1; i <= daysFromNextMonth; i++) {
                const dayElement = document.createElement('div');
                dayElement.className = 'calendar-day other-month';
                dayElement.textContent = i;
                grid.appendChild(dayElement);
            }

            calendar.appendChild(grid);

            // Add action buttons
            const actions = document.createElement('div');
            actions.className = 'calendar-actions';

            const cancelBtn = document.createElement('button');
            cancelBtn.textContent = 'Cancel';
            cancelBtn.addEventListener('click', () => {
                document.body.removeChild(overlay);
            });

            const todayBtn = document.createElement('button');
            todayBtn.textContent = 'Today';
            todayBtn.addEventListener('click', () => {
                inputElement.value = formatDateString(today);
                // Trigger change event
                const event = new Event('change', { bubbles: true });
                inputElement.dispatchEvent(event);
                document.body.removeChild(overlay);
            });

            actions.appendChild(cancelBtn);
            actions.appendChild(todayBtn);
            calendar.appendChild(actions);
        }

        // Initial render
        renderCalendar(currentMonth, currentYear);

        // Add calendar to overlay
        overlay.appendChild(calendar);

        // Add overlay to document
        document.body.appendChild(overlay);

        // Close when clicking outside
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                document.body.removeChild(overlay);
            }
        });
    }

    // Monitor logistics dropdown changes
    document.addEventListener('change', (e) => {
        if (e.target.name === 'logistics') {
            const dateInputs = document.querySelectorAll('input[type="date"]');
            dateInputs.forEach(input => {
                if (e.target.value === 'Collect') {
                    input.setAttribute('data-restrict-weekends', 'true');

                    // Check if current date is a weekend and handle it
                    if (input.value && isWeekend(input.value)) {
                        // This would get handled by the React component's handleLogisticsChange
                        // We're just adding an extra layer of validation here
                    }
                } else {
                    input.removeAttribute('data-restrict-weekends');
                }
            });
        }
    });
});